export default (theme) => ({
  container: {
    padding: 5,
  },
  link: {
    textDecoration: "none",
    color: theme.palette.primary.color[500],
  },
});
